export const findPosts = ({ target = undefined, reset = undefined, cats = undefined, after = undefined, before = undefined, page = undefined, limit = undefined, pageView = false }) => ({
  type: 'FIND_POSTS',
  target,
  reset,
  cats,
  after,
  before,
  page,
  limit,
  pageView
})

export const getPost = (id, pageView = false) => ({
  type: 'GET_POST',
  id,
  pageView
})



// WEBPACK FOOTER //
// ./src/actions/posts.js